module.exports = "mutation($keys: [MJKeyInput!]) {\n    createMJKey(keys: $keys)\n}\n"